module.exports = __webpack_public_path__ + "img/adabc17.png";